import { useState } from 'react';

const travelIcons = [
  { icon: 'ri-plane-line', top: '10%', left: '5%', rotate: '-20deg', size: 'text-4xl', opacity: 'opacity-[0.06]' },
  { icon: 'ri-plane-fill', top: '60%', left: '12%', rotate: '15deg', size: 'text-2xl', opacity: 'opacity-[0.05]' },
  { icon: 'ri-ship-line', top: '20%', left: '25%', rotate: '0deg', size: 'text-3xl', opacity: 'opacity-[0.06]' },
  { icon: 'ri-train-line', top: '70%', left: '30%', rotate: '-10deg', size: 'text-2xl', opacity: 'opacity-[0.05]' },
  { icon: 'ri-hotel-line', top: '15%', left: '70%', rotate: '5deg', size: 'text-3xl', opacity: 'opacity-[0.06]' },
  { icon: 'ri-landscape-line', top: '65%', left: '75%', rotate: '-5deg', size: 'text-3xl', opacity: 'opacity-[0.05]' },
  { icon: 'ri-plane-line', top: '40%', left: '88%', rotate: '30deg', size: 'text-4xl', opacity: 'opacity-[0.06]' },
  { icon: 'ri-building-2-line', top: '50%', left: '55%', rotate: '0deg', size: 'text-2xl', opacity: 'opacity-[0.04]' },
  { icon: 'ri-sun-line', top: '80%', left: '90%', rotate: '0deg', size: 'text-2xl', opacity: 'opacity-[0.05]' },
  { icon: 'ri-map-pin-line', top: '35%', left: '3%', rotate: '0deg', size: 'text-2xl', opacity: 'opacity-[0.05]' },
  { icon: 'ri-compass-3-line', top: '85%', left: '48%', rotate: '15deg', size: 'text-3xl', opacity: 'opacity-[0.06]' },
  { icon: 'ri-flight-takeoff-line', top: '5%', left: '50%', rotate: '-5deg', size: 'text-3xl', opacity: 'opacity-[0.05]' },
];

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email.trim()) return;
    setStatus('loading');
    try {
      const body = new URLSearchParams({ email });
      const res = await fetch('https://readdy.ai/api/form/d74gr06csbv12mkud4bg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      if (res.ok) {
        setStatus('success');
        setEmail('');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section className="relative py-20 px-6 bg-gradient-to-br from-teal-50 via-emerald-50/60 to-white border-y border-teal-100 overflow-hidden">
      {/* Travel icons background */}
      {travelIcons.map((item, i) => (
        <span
          key={i}
          className={`absolute pointer-events-none select-none text-teal-500 ${item.size} ${item.opacity}`}
          style={{ top: item.top, left: item.left, transform: `rotate(${item.rotate})` }}
        >
          <i className={item.icon} />
        </span>
      ))}

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <p className="text-sm font-medium uppercase tracking-wider mb-3 bg-gradient-to-r from-teal-500 to-emerald-500 bg-clip-text text-transparent">Newsletter</p>
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-900 mb-3 tracking-tight">
          Get AI Tips for Travel Agencies
        </h2>
        <p className="text-sm text-gray-500 mb-8 leading-relaxed">
          Weekly strategies on AI automation, WhatsApp marketing, and booking conversion — delivered to your inbox.
        </p>

        {status === 'success' ? (
          <div className="flex items-center justify-center gap-2 text-sm text-emerald-600 font-medium">
            <i className="ri-checkbox-circle-fill text-base" />
            You&apos;re subscribed! Welcome to the community.
          </div>
        ) : (
          <form
            data-readdy-form
            id="trewaz-newsletter-form"
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          >
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your work email"
              required
              className="flex-1 border border-teal-200 rounded-md px-4 py-2.5 text-sm text-gray-800 placeholder-gray-400 outline-none focus:border-teal-400 transition-colors bg-white/80 backdrop-blur-sm"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="bg-gradient-to-r from-teal-500 to-emerald-500 text-white text-sm font-medium px-5 py-2.5 rounded-md hover:from-teal-600 hover:to-emerald-600 transition-all disabled:opacity-50 cursor-pointer whitespace-nowrap"
            >
              {status === 'loading' ? 'Subscribing…' : 'Subscribe'}
            </button>
          </form>
        )}

        {status === 'error' && (
          <p className="text-xs text-red-500 mt-3">Something went wrong. Please try again.</p>
        )}

        <p className="text-xs text-gray-400 mt-4">No spam. Unsubscribe anytime.</p>
      </div>
    </section>
  );
}
